//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

import { of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { combineEpics, ofType } from 'redux-observable'
import moment from 'moment-timezone'
import { OPEN_PACKAGE_LOGS } from './actionTypes'
import { setStartDate, setEndDate } from './actions'

const resetDatesEpic = actions$ => actions$.pipe(
  ofType(OPEN_PACKAGE_LOGS),
  mergeMap(() => {
    const currentDate = moment.tz({}, 'America/Los_Angeles')
    const newEndDate = currentDate.toDate() // TODO: send timezone through payload
    const newStartDate = currentDate.clone().days(-30).toDate()
    return of(
      setStartDate(newStartDate),
      setEndDate(newEndDate),
    )
  }),
)

export default combineEpics(
  resetDatesEpic,
)
